import logException from './utils/raven';
import createHistory from 'history/lib/createBrowserHistory';
import useScroll from 'scroll-behavior/lib/useStandardScroll';
import 'babel-polyfill';
let browserHistory = useScroll(createHistory);

import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, applyMiddleware, compose, combineReducers } from 'redux';

//import { devTools } from 'redux-devtools';
//import { DevTools, DebugPanel, LogMonitor } from 'redux-devtools/lib/react';

import { Provider } from 'react-redux';
import rootReducer from './reducers/index';
import thunk from 'redux-thunk';
import { StripeProvider } from 'react-stripe-elements';

// ROUTE
import { routerStateReducer, reduxReactRouter, ReduxRouter } from 'redux-router';
import { routes } from './routes';

import normalize from 'normalize.css';
import main from './main.scss';

import gaPush from './utils/gaTrack';

//connect(state => ({ routerState: state.router }));

import AccountCaseCreateStep3 from './components/account/caseCreate/step3';

let history = browserHistory();

let storeCompose = [
	applyMiddleware(thunk),
	reduxReactRouter({
		createHistory: () => history,
	}),
	(__DEBUG__ && window.devToolsExtension) ? window.devToolsExtension() : f => f,
];

// Add DEBUG panel if run with 'ENV DEBUG=true'
//__DEBUG__ && storeCompose.push(devTools());
const store = compose(...storeCompose)(createStore)(rootReducer);

try {
	ReactDOM.render((
		<Provider store={store}>
			<StripeProvider apiKey={window.konfig.stripeKey}>
				<ReduxRouter>
					{routes}
				</ReduxRouter>
			</StripeProvider>
		</Provider>
	), document.getElementById('root'));
} catch (e) {
	logException(e, {
		screenDimensions: screen.width + 'x' + screen.height,
		windowDimensions: window.innerWidth + 'x' + window.innerHeight,
	});
}

history && history.listen((e) => {
	// console.log('HISTORY!');
	gaPush();

	if (!('remove' in Element.prototype)) {
		// FIX Browser not supporting Element.remove(); -- Looking at you IE!
		Element.prototype.remove = function remove() {
			if (this.parentNode) {
				this.parentNode.removeChild(this);
			}
		};
	}

	if (document.querySelector('link[rel="prev"]')) {
		document.querySelector('link[rel="prev"]').remove();
	}
	if (document.querySelector('link[rel="next"]')) {
		document.querySelector('link[rel="next"]').remove();
	}
	if (document.querySelector('link[rel="canonical"]')) {
		document.querySelector('link[rel="canonical"]').remove();
	}

	if (document.querySelector('meta[name="description"].inserted')) {
		document.querySelector('meta[name="description"].inserted').remove();
	}
	let link = '<link rel="canonical" href="' + window.location.href + '">';

	if (e.pathname !== '/' && e.pathname.indexOf('/awards/') == -1) {
		document.querySelector('head').insertAdjacentHTML('beforeend', link);
	}
});

//select={state => state.menu}



/** WEBPACK FOOTER **
 ** ./frontend/main.js
 **/